import { z } from "zod";
import { schedulingConnectionDiscoverySchema, schedulingConsentSelectionSchema } from "./scheduling-connections.js";
export const schedulingProviderNameSchema = z.enum(["google", "microsoft", "apple"]);
export const schedulingConnectionIdSchema = z.string().uuid();
export const schedulingConnectionListResponseSchema = z.object({ connections: z.array(z.object({
        id: schedulingConnectionIdSchema, provider: schedulingProviderNameSchema,
        discovery: schedulingConnectionDiscoverySchema, revokedAt: z.number().int().nullable(),
    }).strict()) }).strict();
export const schedulingDiscoveryResponseSchema = z.object({ discovery: schedulingConnectionDiscoverySchema }).strict();
export const schedulingConnectResponseSchema = schedulingDiscoveryResponseSchema.extend({ connectionId: schedulingConnectionIdSchema }).strict();
export const schedulingConnectionRequestSchema = z.object({ connectionId: schedulingConnectionIdSchema }).strict();
export const schedulingConsentRequestSchema = schedulingConnectionRequestSchema.extend({
    selection: schedulingConsentSelectionSchema, idempotencyKey: z.string().regex(/^[A-Za-z0-9_-]{16,128}$/u),
}).strict();
export const schedulingConsentResponseSchema = z.object({ grantId: z.string().uuid(), connectionId: schedulingConnectionIdSchema,
    destinationCalendarId: z.string().min(1), conflictCalendarIds: z.array(z.string().min(1)) }).strict();
/** Internal server-to-server OAuth handoff. Never a public connection response or native credential upload. */
export const schedulingOAuthHandoffSchema = z.object({
    kind: z.literal("scheduling-connection"), connectionId: schedulingConnectionIdSchema,
    organisationId: z.string().min(1), provider: z.enum(["google", "microsoft"]),
    expectedSubject: z.string().min(1).max(2048), accountLabel: z.string().min(1).max(200),
    credential: z.object({ accessToken: z.string().min(1).max(32768), refreshToken: z.string().min(1).max(32768),
        issuerClientId: z.string().min(1).max(2048), expiresAt: z.number().int().positive(), scope: z.string().min(1).max(8192),
        tenantId: z.string().uuid().optional() }).strict(),
}).strict().superRefine((value, ctx) => {
    if (value.provider === "microsoft" && !value.credential.tenantId)
        ctx.addIssue({ code: "custom", message: "Microsoft tenant required" });
});
export const schedulingAppleConnectionRequestSchema = z.object({ connectionId: schedulingConnectionIdSchema,
    username: z.string().min(1).max(320), appPassword: z.string().min(1).max(256),
    serverCredentialConsent: z.literal(true),
}).strict();
